// extracted by mini-css-extract-plugin
export default {"taskFormFromTasksContainer":"TaskFormForShowInTaskDetail_taskFormFromTasksContainer__UoGGO"};